import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../../components/Private/Navbar'
import ListSection from '../../../components/Private/ListSection'
import ModalComponent from '../../../components/Private/ModalComponent'

import contestService from '../../../services/contests'
import categorygroupService from '../../../services/categorygroups'
import categoryService from '../../../services/categories'

export default function List() {

  const navigateTo = useNavigate()
  const params = useParams()
  const [parentData, setParentData] = useState({
    id: params.categoryGroup_id,
    contest_id: '',
    contestName: '',
    categoryGroupName: '',
  })

  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorModalTitle, setErrorModalTitle] = useState('Error')
  const [errorMessage, setErrorMessage] = useState('')

  const [showAddModal, setShowAddModal] = useState(false)
  const [addModalTitle, setAddModalTitle] = useState('Crear categoría')
  const [showEditModal, setShowEditModal] = useState(false)
  const [editModalTitle, setEditModalTitle] = useState('Editar categoría')
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deleteModalTitle, setDeleteModalTitle] = useState('Borrar categoría')

  const categoryTypeList = {
    'simple': 'Simple',
    'multiple': 'Múltiple',
  };

  const [listData, setListData] = useState(null)

  const [selectedItemId, setSelectedItemId] = useState(null)

  const [formData, setFormData] = useState({
    categoryGroup_id: params.categoryGroup_id,
    categoryName: '',
    categoryType: 'simple',
  })

  const handleFieldChange = (event) => {
    setFormData(
      {
        ...formData,
        [event.target.name]: event.target.value
      }
    )
  }

  useEffect(() => {
  }, [formData])

  const getFormDOM = () => {
    return <>
      <div className='mb-3'>
        <label htmlFor='categoryName' className='form-label'>Nombre de categoría</label>
        <input
          name='categoryName'
          id='categoryName'
          type='text'
          className='form-control'
          placeholder='Nombre de categoría'
          value={formData.categoryName}
          onChange={
            (event) => {
              handleFieldChange(event)
            }
          }
        />
      </div>
      <div className='mb-3'>
        <label htmlFor='categoryType' className='form-label'>Tipo de categoría</label>
        <select
          name='categoryType'
          id='categoryType'
          className='form-select'
          value={formData.categoryType}
          onChange={
            (event) => {
              handleFieldChange(event)
            }
          }
        >
          {
            Object.keys(categoryTypeList).map((key, index) => {
              return <option key={index} value={key}>{categoryTypeList[key]}</option>
            })
          }
        </select>
      </div>
    </>
  }

  const handleDataCreate = async () => {
    try {
      await categoryService.create(formData)
      await handleDataLoad()
      setShowAddModal(false)
      setSelectedItemId(null)
    } catch (error) {
      setErrorMessage(error.response.data.messages.error)
      setShowErrorModal(true)
    }
  }

  const handleDataUpdate = async (itemId) => {
    try {
      await categoryService.update(itemId, formData)
      await handleDataLoad()
      setShowEditModal(false)
      setSelectedItemId(null)
    } catch (error) {
      setErrorMessage(error.response.data.messages.error)
      setShowErrorModal(true)
    }
  }

  const handleDataDelete = async (itemId) => {
    await categoryService.remove(itemId)
    await handleDataLoad()
  }

  const handleDataLoad = async () => {

    const categoryGroup = await categorygroupService.get(params.categoryGroup_id)
    const contest = await contestService.get(categoryGroup.contest_id)

    setParentData({
      ...parentData,
      contest_id: contest.id,
      contestName: contest.contestName,
      categoryGroupName: categoryGroup.categoryGroupName,
    })

    const result = await categoryService.byCategoryGroup(params.categoryGroup_id)
    setListData(result)
  }

  useEffect(() => {
    handleDataLoad()
  }, [])

  return (
    <>
      <Navbar />
      {
        listData &&
        <ListSection
          pagination={
            {
              itemsPerPage: 5,
              maxPagesInPagination: 5,
              currentPage: 1,
              prevPage: 'Anterior',
              nextPage: 'Siguiente',
              lastPage: 'Última',
            }
          }
          title={`Categorías de ${parentData.categoryGroupName}`}
          hasSearch={true}
          hasYear={false}
          tabs={false}
          backRoute={
            {
              title: 'Volver',
              onClick: () => {
                navigateTo('/categorygroups/' + parentData.contest_id)
              }
            }
          }
          actions={
            {
              title: 'Crear categoría',
              onClick: () => {
                setFormData({
                  ...formData,
                  categoryName: '',
                  categoryType: 'simple',
                })
                setShowAddModal(true)
              }
            }
          }
          columns={
            [
              {
                title: 'Nombre',
                field: 'categoryName',
                type: 'text',
                sortable: true,
              },
              {
                title: 'Tipo',
                field: 'categoryType',
                type: 'text',
                sortable: true,
              },
              {
                title: 'Acciones',
                field: 'actions',
                type: 'actions',
              },
            ]
          }
          rows={
            [
              ...listData.map((item, index) => {
                return {
                  categoryName: item.categoryName,
                  categoryType: categoryTypeList[item.categoryType],
                  actions: [
                    {
                      className: 'btn',
                      icon: 'bi bi-tags',
                      tooltip: 'Gestionar etiquetas',
                      onClick: () => {
                        navigateTo('/tags/' + item.id)
                      }
                    },
                    {
                      className: 'btn',
                      icon: 'bi bi-pencil',
                      tooltip: 'Editar',
                      onClick: () => {
                        setFormData({
                          ...formData,
                          categoryName: item.categoryName,
                          categoryType: item.categoryType,
                        })
                        setSelectedItemId(item.id)
                        setEditModalTitle('Editar ' + item.categoryName)
                        setShowEditModal(true)
                      }
                    },
                    {
                      className: 'btn',
                      icon: 'bi bi-trash',
                      tooltip: 'Borrar',
                      onClick: () => {
                        setSelectedItemId(item.id)
                        setDeleteModalTitle('Borrar ' + item.categoryName)
                        setShowDeleteModal(true)
                      }
                    }
                  ],
                }
              })
            ]
          }
        />
      }
      <ModalComponent
        id='createModal'
        title={addModalTitle}
        show={showAddModal}
        setShow={setShowAddModal}
      >
        {getFormDOM()}
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowAddModal(false)
              setSelectedItemId(null)
            }}
          >
            Cancelar
          </button>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => {
              handleDataCreate()
            }}
          >
            Crear
          </button>
        </div>
      </ModalComponent>
      <ModalComponent
        id='editModal'
        title={editModalTitle}
        show={showEditModal}
        setShow={setShowEditModal}
      >
        {getFormDOM()}
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowEditModal(false)
              setSelectedItemId(null)
            }}
          >
            Cancelar
          </button>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => {
              handleDataUpdate(selectedItemId)
            }}
          >
            Guardar
          </button>
        </div>
      </ModalComponent>
      <ModalComponent
        id='deleteModal'
        title={deleteModalTitle}
        show={showDeleteModal}
        setShow={setShowDeleteModal}
      >
        <p>¿Está seguro que desea borrar esta categoría?</p>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowDeleteModal(false)
              setSelectedItemId(null)
            }}
          >
            Cancelar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => {
              handleDataDelete(selectedItemId)
              setShowDeleteModal(false)
              setSelectedItemId(null)
            }}
          >
            Borrar
          </button>
        </div>
      </ModalComponent>
      <ModalComponent
        id='errorModal'
        title={errorModalTitle}
        show={showErrorModal}
        setShow={setShowErrorModal}
        headerClass='bg-danger text-white'
        modalSize='modal-lg'
      >
        <p>{errorMessage}</p>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowErrorModal(false)
              setSelectedItemId(null)
            }}
          >
            Ok
          </button>
        </div>
      </ModalComponent>
    </>
  )
}
